import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

import Config from '../config/main.es6';
import Utils from '../utils/main.es6';
import FvGood from './good/main.es6';
import Counter from './counter/main.es6';


export default class FirstView{
    
    constructor(){
        this.good = null;
        this.isGoodHide = false;
        this.$howtoOpen = document.querySelector('.js-howto_open');
        this._init();
    }


    _init(){
        this.query = Utils.getQuery() || {};

        this.counter = new Counter();
        this.good = new FvGood();

        // 未クリア(〜68999)
        if(!BOCCHI.hashCount.isClear){

            this.good.render(()=>{
                document.body.classList.add('-top_ready');

                setTimeout(()=>{
                    this.counter.countup();
                }, 1500);
                
                this._setGoodHideTrigger();
            });
        }
        // クリア(69000〜)
        else{

            // 初回のみクリア演出を見せる
            let isClearviewed = BOCCHI.LDATA.getData('clearviewed');
            if(this.query.tasseiview === '1') isClearviewed = false;

            if(!isClearviewed){
                document.body.setAttribute('data-clearviewed', '0');
                BOCCHI.LDATA.setData('clearviewed', true);
            }
            else{
                document.body.setAttribute('data-clearviewed', '1');
            }

            this.good.render(()=>{
                
                // Goodアイコンを非表示に
                setTimeout(()=>{
                    this._goodHide();
                }, 1700);

                // カウンターを表示する
                setTimeout(()=>{
                    document.body.classList.add('-top_ready');
                }, 3000);
                setTimeout(()=>{
                    this.counter.countup();
                }, 5000);

                this._stopCounterGrad();
                document.body.classList.add('-clear_ready');
            });
        }

        this._howtoShow();
    }


    _setGoodHideTrigger(){
        
        // 未クリアのときはスクロールすると指アイコンが吹き飛ぶ
        ScrollTrigger.create({
            trigger: document.querySelector('.js-scene'),
            start: "top 80%",
            onEnter: ()=>{
                this._goodHide();
            },
            onLeaveBack: ()=>{}
        });
    }

    _goodHide(){
        if(this.isGoodHide) return;
        this.good.hide();
        this.isGoodHide = true;
        document.querySelector('.contentsbg').classList.add('-attention');
    }


    _stopCounterGrad(){
        console.log('SCROLLED');

        ScrollTrigger.create({
            trigger: document.querySelector('.js-scene'),
            start: "top 80%",
            onEnter: ()=>{
                // 69000以上のカウンターのグラデーション止める
                const $counterGradation = document.querySelector('.js-counter_gradation');
                $counterGradation.classList.add('-scrolled');
            },
            onLeaveBack: ()=>{}
        });
    }


    _howtoShow(){
        const isHowtoViewed = BOCCHI.LDATA.getData('howtoViewed');
        if(isHowtoViewed) return;

        document.querySelector('.js-fv__counter').addEventListener('transitionend', ()=>{

            setTimeout(()=>{
                this.$howtoOpen.click();
                BOCCHI.LDATA.setData('howtoViewed', true);
            }, 3000);
        });
    }
}